import { render } from "./PieChart.vue?vue&type=template&id=4d772aee"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
script.render = render

export default script